(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-prayer-set"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = (value) => (value || '').toLocaleLowerCase('tr-TR').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/\s+/g, ' ').trim();

  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const revealItems = root.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const hero = root.querySelector('[data-hero-parallax]');
    if (hero && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = event.clientX / rect.width - rect.left / rect.width - .5;
        const y = event.clientY / rect.height - rect.top / rect.height - .5;
        hero.style.setProperty('--hero-x', `${x * -12}px`);
        hero.style.setProperty('--hero-y', `${y * -8}px`);
        hero.style.setProperty('--hero-card-x', `${x * 18}px`);
        hero.style.setProperty('--hero-card-y', `${y * 14}px`);
      });
      hero.addEventListener('pointerleave', () => {
        hero.style.setProperty('--hero-x', '0px');
        hero.style.setProperty('--hero-y', '0px');
        hero.style.setProperty('--hero-card-x', '0px');
        hero.style.setProperty('--hero-card-y', '0px');
      });
    }

    const cards = [...root.querySelectorAll('[data-color-card]')];
    const track = root.querySelector('[data-color-track]');
    const featureImage = root.querySelector('[data-feature-image]');
    const colorSelectors = [...root.querySelectorAll('[data-purchase-color]')];
    const colorLabels = [...root.querySelectorAll('[data-selected-color]')];
    const sizeSelectors = [...root.querySelectorAll('[data-purchase-size]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const buyButton = root.querySelector('[data-buy-button]');
    const priceLabels = [...root.querySelectorAll('[data-price]')];
    let selectedColor = cards[0]?.dataset.color || 'Bordo';
    let selectedSize = sizeSelectors[0]?.dataset.purchaseSize || '';
    let variants = [];

    const variantJson = root.querySelector('[data-product-variants]');
    if (variantJson) {
      try { variants = JSON.parse(variantJson.textContent); } catch (error) { variants = []; }
    }

    const updateVariant = () => {
      if (!variants.length) return;
      const wantedColor = normalize(selectedColor);
      const wantedSize = normalize(selectedSize);
      const sizeNumber = wantedSize.match(/(?:beden\s*)?(\d)/)?.[1];
      const variant = variants.find((item) => {
        const options = (item.options || []).map(normalize);
        const hasColor = options.some((option) => option === wantedColor || option.includes(wantedColor));
        const hasSize = !sizeNumber || options.some((option) => option === sizeNumber || option.includes(`beden ${sizeNumber}`) || option.startsWith(`${sizeNumber} `));
        return hasColor && hasSize;
      });
      if (!variant) {
        if (buyButton) { buyButton.disabled = true; buyButton.querySelector('span').textContent = 'Bu seçenek bulunamadı'; }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (buyButton) {
        buyButton.disabled = !variant.available;
        buyButton.querySelector('span').textContent = variant.available ? 'Sepete ekle' : 'Tükendi';
      }
      if (variant.price != null) {
        const price = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(variant.price / 100);
        priceLabels.forEach((label) => { label.textContent = price; });
      }
    };

    const selectCard = (card, shouldScroll = false) => {
      if (!card) return;
      selectedColor = card.dataset.color;
      cards.forEach((item) => item.classList.toggle('is-active', item === card));
      colorSelectors.forEach((item) => item.classList.toggle('is-active', normalize(item.dataset.purchaseColor) === normalize(selectedColor)));
      colorLabels.forEach((label) => { label.textContent = selectedColor; });
      root.style.setProperty('--accent', card.dataset.accent || '#713246');
      if (featureImage) {
        featureImage.style.opacity = '0';
        window.setTimeout(() => {
          featureImage.src = card.dataset.image;
          featureImage.alt = `Seçili renk: ${selectedColor}`;
          featureImage.style.opacity = '1';
        }, 180);
      }
      if (shouldScroll) card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      updateVariant();
    };

    cards.forEach((card) => card.addEventListener('click', () => selectCard(card, true)));
    colorSelectors.forEach((selector) => selector.addEventListener('click', () => {
      const card = cards.find((item) => normalize(item.dataset.color) === normalize(selector.dataset.purchaseColor));
      selectCard(card, false);
    }));
    sizeSelectors.forEach((selector) => selector.addEventListener('click', () => {
      selectedSize = selector.dataset.purchaseSize;
      sizeSelectors.forEach((item) => item.classList.toggle('is-active', item === selector));
      updateVariant();
    }));

    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -(track.clientWidth * 0.72), behavior: 'smooth' }));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => track?.scrollBy({ left: track.clientWidth * 0.72, behavior: 'smooth' }));

    if (track && cards.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let activeIndex = 0;
      let timer;
      const start = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => {
          activeIndex = (activeIndex + 1) % cards.length;
          selectCard(cards[activeIndex], true);
        }, 4200);
      };
      const stop = () => window.clearInterval(timer);
      track.addEventListener('mouseenter', stop);
      track.addEventListener('mouseleave', start);
      track.addEventListener('focusin', stop);
      track.addEventListener('focusout', start);
      track.addEventListener('pointerdown', stop, { passive: true });
      start();
    }

    selectCard(cards[0], false);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-prayer-landing]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
